export const getImageSrcSet = (url) => {
  if (!url) {
    return ''
  }

  // These types are the images that correspons "best"
  // to the wanted images.
  // We want for small images 120, 240 and 360 width images
  // For medium images we want 180, 360 and 540 width images
  // to account for 1x 2x 3x pixel density
  // The types can be fetched using the `image_types` classefieds api
  return `
    ${url}?type=thumb 120w,
    ${url}?type=gallery_big 180w,
    ${url}?type=mob_iphone_vi_normal 240w,
    ${url}?type=store_presentation 360w,
    ${url}?type=mob_iphone_vi_normal_retina 540w,
  `
}
